import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { AdvancedMarker, APIProvider, InfoWindow, Map, useMap } from '@vis.gl/react-google-maps'
import { useCallback, useEffect, useRef, useState } from 'react'
import Loader from '../../../../Components/Common/Loader'
import { iconsSrc } from './iconsSrc'
import InfoWindowContent from './InfoWindowContent/InfoWindowContent'
import style from './MapProperty.module.css'

const API_KEY = process.env.REACT_APP_GOOGLEMAPAPIKEY
const MAP_ID = process.env.REACT_APP_GOOGLEMAPID ?? 'DEMO_MAP_ID' 

const mapPosition = { lat: 44, lng: 16 }

const PropertyMarkers = ({ properties, selectedProperty, onMarkerClick, onInfoWindowClose }) => {
    const map = useMap()
    const markers = useRef({})
    const clusterer = useRef(null)

    // Effect to initialise MarkerClusterer once the map is ready
    useEffect(() => {
        if (!map) return

        clusterer.current = new MarkerClusterer({ map })

        return () => clusterer.current?.clearMarkers()
    }, [map])

    const setMarkerRef = useCallback((marker, key) => {
        if (marker) {
            markers.current[key] = marker
        } else {
            delete markers.current[key]
        }

        clusterer.current?.clearMarkers()
        clusterer.current?.addMarkers(Object.values(markers.current))
    }, [])

    const handleMarkerClick = (property) => {
        onMarkerClick(property)
        map?.panTo({ lat: parseFloat(property.mapLatitude), lng: parseFloat(property.mapLongitude) })
    }

    return (
        <>
            {properties
                .filter((item) => {
                    const lat = parseFloat(item.mapLatitude)
                    const lng = parseFloat(item.mapLongitude)
                    return !isNaN(lat) && !isNaN(lng)
                })
                .map((item) => {
                    const icon = iconsSrc.find((icon) => icon?.id === item.propertyType?.id)

                    return (
                        <AdvancedMarker
                            key={item.id}
                            position={{ lat: parseFloat(item.mapLatitude), lng: parseFloat(item.mapLongitude) }}
                            ref={(marker) => setMarkerRef(marker, item.id)}
                            onClick={() => handleMarkerClick(item)}
                        >
                            <img src={icon?.src} alt="" />
                        </AdvancedMarker>
                    )
                })}

            {selectedProperty && (
                <InfoWindow
                    position={{ lat: parseFloat(selectedProperty.mapLatitude), lng: parseFloat(selectedProperty.mapLongitude) }}
                    onCloseClick={onInfoWindowClose}
                >
                    <InfoWindowContent {...selectedProperty} />
                </InfoWindow>
            )}
        </>
    )
}

const MapProperty = ({ tableActions, properties, isDataLoading }) => {
    const [selectedProperty, setSelectedProperty] = useState(null)

    return (
        <>
            {tableActions()}

            {!isDataLoading ? (
                <APIProvider apiKey={API_KEY}>
                    <Map
                        className={style.mapContainer}
                        defaultCenter={mapPosition}
                        defaultZoom={7}
                        gestureHandling="cooperative"
                        mapId={MAP_ID}
                        onZoomChange={() => setSelectedProperty(null)}
                    >
                        <PropertyMarkers
                            properties={properties}
                            selectedProperty={selectedProperty}
                            onMarkerClick={setSelectedProperty}
                            onInfoWindowClose={() => setSelectedProperty(null)}
                        />
                    </Map>
                </APIProvider>
            ) : (
                <div className="text-center d-flex justify-content-center" style={{ position: 'absolute', inset: '100px 0' }}>
                    <Loader />
                </div>
            )}
        </>
    )
}

export default MapProperty
